// Global styles
const styles = ({ app, palette, breakpoints }) => ({
  '@global': {
    html: {
      width: '100%',
      height: '100%',
      margin: 0,
      fontSize: 16,
      overflow: 'hidden',

      [breakpoints.up('xl')]: {
        fontSize: '0.833333vw !important',
      },
    },
    '@keyframes autofill': {
      '100%': {
        background: 'transparent',
      },
    },
    body: {
      width: '100%',
      minWidth: app.minWidth,
      height: '100%',
      margin: 0,
      overflow: 'hidden',
      backgroundColor: palette.common.white,
    },
    input: {
      '&:-webkit-autofill': {
        WebkitAnimationName: 'autofill',
        WebkitAnimationFillMode: 'both',
      },
      '&::-ms-clear': {
        display: 'none !important',
      },
    },
    svg: {
      display: 'block',
    },
  },
  container: {
    overflow: 'hidden',

    '& > div': {
      width: '100%',
    },
  },
});

export default styles;
